import { render, staticRenderFns } from "./AutomationsLogs.vue?vue&type=template&id=147c2e48&"
import script from "./AutomationsLogs.vue?vue&type=script&lang=js&"
export * from "./AutomationsLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports